import React from 'react';
import { motion } from 'framer-motion';
import Container from '../../layout/Container';

const statsData = [
  { value: '15+', label: 'Years Experience' },
  { value: '500+', label: 'Happy Clients' },
  { value: '2000+', label: 'Projects Completed' },
  { value: '24/7', label: 'Support Available' },
];

const Stats = () => {
  return (
    <section className="py-16 bg-blue-600 text-white">
      <Container>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 lg:gap-10">
          {statsData.map((stat, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="text-center"
            >
              <div className="text-4xl md:text-5xl font-bold mb-2">{stat.value}</div>
              <div className="text-blue-200">{stat.label}</div>
            </motion.div>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default Stats;